var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
var NotificationComponent = /** @class */ (function (_super) {
    __extends(NotificationComponent, _super);
    function NotificationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationComponent.prototype.generateNotification = function (notification) {
        this.props.dispatch({
            action: "delete",
            payload: { id: notification.id, channel: "notifications" },
        });
        switch (notification.type) {
            case "SUCCESS":
                return toast.success(notification.message);
            case "INFO":
                return toast.info(notification.message);
            case "ERROR":
                return toast.error(notification.message);
            case "WARNING":
                return toast.warn(notification.message);
            default:
                return null;
        }
    };
    NotificationComponent.prototype.componentWillReceiveProps = function (newProps) {
        var _this = this;
        Object.keys(newProps.notifications).map(function (notificationId) {
            _this.generateNotification(newProps.notifications[notificationId]);
        });
    };
    NotificationComponent.prototype.render = function () {
        var TC = ToastContainer;
        return React.createElement(TC, { position: toast.POSITION.TOP_RIGHT });
    };
    return NotificationComponent;
}(Component));
export default NotificationComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/common/Notifications.tsx
// module id = 1286
// module chunks = 0